export const CheckTimeStampIsNaN = (date: FirebaseFirestore.Timestamp) => {
  return Number.isNaN(date.seconds);
};
